import http from "@/utils/http";
const prefixUrl = "/Index/detailRahuday.html";
export default {
  query(params = {}) {
    return http.get(prefixUrl, { params });
  },
};
